import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Dialog, Form } from "@sscs/ui";
import { PURL_SAFE_HELP_MESSAGE } from "Constants";
import { ProjectFormData } from "Types";
import SelectCreateAutocomplete from "../SelectCreateAutocomplete/SelectCreateAutocomplete";

type ProjectStepProps = {
  projects: string[];
};

const ProjectStep = ({ projects }: ProjectStepProps): React.JSX.Element => {
  const formMethods = useFormContext<ProjectFormData>();
  const { setFocus, formState } = formMethods;

  const [isCreatingMode, setIsCreatingMode] = useState(false);

  useEffect(() => {
    if (isCreatingMode) {
      setFocus("project_description");
    }
  }, [isCreatingMode, setFocus]);

  return (
    <Dialog.Section>
      <Dialog.Section.Title>
        Select project or create new one
      </Dialog.Section.Title>
      <Dialog.Section.Description>
        If the project you are searching for doesn&apos;t exist, an option to
        create it will appear.
      </Dialog.Section.Description>
      <Dialog.Section.Content>
        <SelectCreateAutocomplete
          id="project-autocomplete"
          name="project_name"
          label="Project name"
          options={projects}
          isCreatingMode={isCreatingMode}
          onModeChange={(isCreatingMode: boolean) =>
            setIsCreatingMode(isCreatingMode)
          }
          helperText={isCreatingMode ? PURL_SAFE_HELP_MESSAGE : undefined}
          placeholder={!isCreatingMode ? "Search projects" : undefined}
        />
        {isCreatingMode ? (
          <Form.TextArea
            name="project_description"
            label="Short description"
            id="project-description"
            errors={formState.errors}
          />
        ) : (
          <></>
        )}
      </Dialog.Section.Content>
    </Dialog.Section>
  );
};

export default ProjectStep;
